var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_858_31110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3911 0C13.5808 0.0559571 15.5195 0.587549 17.2715 1.71764C19.8293 3.36837 21.6135 5.60909 22.9304 8.21961C23.0269 8.41059 23.0231 8.56995 22.9291 8.75971C21.5813 11.4675 19.7379 13.8129 17.0269 15.4077C13.6066 17.4185 10.0356 17.5352 6.48784 15.6972C4.37798 14.6036 2.73797 12.9893 1.44553 11.0771C0.929329 10.3131 0.4968 9.4981 0.0462487 8.69524C-0.0155412 8.58454 -0.0116794 8.39599 0.0462487 8.27921C1.50346 5.28186 3.62234 2.82583 6.67836 1.16415C7.92961 0.48415 9.30701 0.155707 10.7423 0.0486583C10.9882 0.0304114 11.2328 0.0121646 11.3898 0H11.3911ZM17.2831 8.48601C17.2818 5.46555 14.7046 3.02655 11.507 3.0156C8.30678 3.00587 5.69874 5.46555 5.7026 8.49209C5.70646 11.5113 8.28619 13.9516 11.4812 13.9601C14.6879 13.9674 17.2843 11.5186 17.2831 8.48601Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.74691 7.79506C8.99043 8.02984 10.2146 8.25975 11.5071 8.50426C11.2535 7.29875 11.0089 6.12973 10.7643 4.96193C11.946 4.63836 13.7547 5.12372 14.6622 6.43628C15.6843 7.91549 15.5209 9.71707 14.2529 11.0138C13.1625 12.1293 11.1865 12.4407 9.72676 11.7169C8.16013 10.9408 7.40578 9.31077 7.74691 7.79385V7.79506Z",
    fill: "#757575"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_858_31110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.60246a4dbae762d3d4a7b4563ef0784d.svg";
export { ForwardRef as ReactComponent };